import axios from 'axios';
import AuthenticationService from '../pages/auth/AuthenticationService';
import API_BASE_URL from "../config";

const HOST = window.location.host;
const instance = axios.create({
    baseUrl: 'https://' + HOST,
    timeout: 30000,
});

instance.interceptors.request.use(
    function (config) {
        const token = localStorage.getItem("token");
        config.headers["Content-Type"] = "application/json; charset=utf-8";
        config.headers["Authorization"] = AuthenticationService.createJWTToken(token);
        return config;
    },
    function (error) {
        return Promise.reject(error);
    }
);

instance.interceptors.response.use(
    (response) => {
        /**
         * http status가 200인 경우 응답 성공 직전 호출됩니다. (응답 데이터 가공)
         * .then() 으로 이어집니다.
         */
        return response;
    },
    async (error) => {
        // 기기로 바로 요청하는 원격명령의 경우에는 응답 에러발생시 interceptor 처리 제외
        //  - 기기 연결 안됐을 경우 요청 타임아웃 발생 (error.message === "Network Error")
        //  - 그러면, 원격명령에 대한 응답인데도 refreshToken 처리를 하려고 하기 때문.
        if (error.config.url.includes('svc/if')) return;

        let errResponseStatus = null;
        const originalRequest = error.config;

        try {
            errResponseStatus = error.response.status;
        } catch (e) {
            console.log(e);
        }
        /**
         * http status가 200이 아닌 경우 응답 에러 직전 호출됩니다. (오류 응답을 처리)
         * .catch() 으로 이어집니다.
         */

        // access token이 만료되어 발생하는 에러인 경우
        // console.log(originalRequest.retry);
        if ((error.message === "Network Error" || errResponseStatus === 401) && !originalRequest.retry) {
            originalRequest.retry = true;

            return await axios.post(`${API_BASE_URL}/api/refresh-jwt`)
                .then((res) => {
                    const resultMessage = res.data.result;
                    const accessToken = res.data.accessToken;
                    if (resultMessage === "success") {
                        localStorage.setItem("token", accessToken);

                        originalRequest.headers["Authorization"] = AuthenticationService.createJWTToken(accessToken);

                        return instance(originalRequest);

                    } else if (resultMessage === "fail") {
                        logout();
                        window.location.href = "/login";
                        alert("[fail]User authentication has expired.\nPlease Login again.");
                        return Promise.reject(error);
                    }
                })
                .catch((e) => {
                    logout();
                    window.location.href = "/login";
                    alert("User authentication has expired.\nPlease Login again.");
                    return Promise.reject(error);
                });
        }
        return Promise.reject(error);
    }
);

const logout = () => {
    localStorage.clear();
    return axios.post(`${API_BASE_URL}/api/logout`);
}

export default instance;
  
